// ========= START: src/components/WelcomeScreen.js (COMPLETE REPLACEMENT) =========
import React from 'react';
import Background from './Background';

function WelcomeScreen({ onStartEcho }) {
  return (
    <div className="welcome-screen">
      <Background background={{ type: 'video', src: `${process.env.PUBLIC_URL}/assets/backgrounds/welcome-bg.mp4` }} />
      <div className="welcome-content">
        <img 
          src={`${process.env.PUBLIC_URL}/assets/logo/bp-echo-logo.png`} 
          alt="BP ECHO Logo" 
          className="welcome-logo" 
        />
        <div className="start-buttons-container">
          <img
            src={`${process.env.PUBLIC_URL}/assets/menu-buttons/start-button.png`}
            alt="Start BP ECHO"
            className="start-button-image"
            onClick={onStartEcho}
          />
          {/* Pronunciation Challenge button has been removed */}
        </div>
        <a href="/" className="back-to-hub-button">↩️ LABO Hub</a>
      </div>
    </div>
  );
}

export default WelcomeScreen;
// ========= END: src/components/WelcomeScreen.js (COMPLETE REPLACEMENT) =========